<!-- <ng-container [formGroup]="formGroup" *ngIf="formGroup">
  <div class="search-bar">
    <input
      *ngIf="isBulkEdit"
      type="text"
      nz-input
      [ngModel]="searchStatement"
      [ngModelOptions]="{ standalone: true }"
      (ngModelChange)="onGroupSearch($event)"
      placeholder="Search for attributes"
    />
  </div>
  <ng-container *ngFor="let attributeGroup of attributeGroups">
    <div
      class="page-content-section"
      [id]="'attribute-group-' + attributeGroup.Id"
    >
      <fieldset>
        <legend>
          {{ attributeGroup.Name }}
        </legend>
      </fieldset>

      <ng-container
        *ngFor="let attribute of attributeGroup | AttributesGroupFields"
      >
        <app-bulk-edit-field
          [field]="attribute"
          [formGroup]="formGroup"
          [isBulkEdit]="isBulkEdit"
          [objectTypeId]="objectTypeId"
          [record]="record"
          [dropDownsMetaData]="dropDownsMetaData"
        ></app-bulk-edit-field>
      </ng-container>
    </div>
  </ng-container>
</ng-container> -->

<ng-container *ngIf="isLoadingData">
  <nz-spin [nzTip]="'Loading attributes...'  | translate" [nzSize]="'large'"></nz-spin>
</ng-container>
<ng-container [formGroup]="formGroup" *ngIf="formGroup">
  <div class="search-bar">
    <input
      *ngIf="isBulkEdit"
      type="text"
      nz-input
      [ngModel]="searchStatement"
      [ngModelOptions]="{ standalone: true }"
      (ngModelChange)="onGroupSearch($event)"
      [placeholder]="'Search for attributes'  | translate"
    />
  </div>

  <ng-container *ngFor="let attributeGroup of paginatedAttributeGroups">
    <div class="page-content-section" [id]="'attribute-group-' + attributeGroup.Id">
      <fieldset>
        <legend>
          {{ attributeGroup.Name }}
        </legend>
      </fieldset>

      


      <ng-container *ngFor="let attribute of attributeGroup | AttributesGroupFields">
        <app-bulk-edit-field
          [field]="attribute"
          [formGroup]="formGroup"
          [isBulkEdit]="isBulkEdit"
          [objectTypeId]="objectTypeId"
          [record]="record"
          [dropDownsMetaData]="dropDownsMetaData"
        ></app-bulk-edit-field>
      </ng-container>
    </div>
  </ng-container>

  
  <div *ngIf="paginatedAttributeGroups.length===0">
    <nz-empty></nz-empty>
  </div>
 
  

  <!-- pagination -->
  <nz-pagination
  *ngIf="paginatedAttributeGroups.length>0"
    [nzPageIndex]="pageIndex"
    [nzPageSize]="pageSize"
    [nzTotal]="totalItmes"
    (nzPageIndexChange)="onPageIndexChange($event)"
  ></nz-pagination>
</ng-container>
